<script setup lang="ts">
import { computed } from "vue";
import { formatDecimal } from "@yawhub/core";
import { dimensionLabel, metricUnit } from "../queryPresentation";
import { TrophyIcon } from "../icons";
const props = defineProps<{ result: any; busy?: boolean }>();
const emit = defineEmits<{ direction: ["asc" | "desc"] }>();
const direction = computed(() => props.result.query.sort?.direction ?? "desc");
const metric = computed(() => props.result.query.metrics[0]);
const unit = computed(() =>
  metricUnit(metric.value, props.result.schema.fields),
);
</script>
<template>
  <div class="ranking-result" :aria-busy="busy">
    <div class="segmented" role="group" aria-label="Rangering">
      <button
        type="button"
        :class="{ selected: direction === 'desc' }"
        :aria-pressed="direction === 'desc'"
        :disabled="busy"
        @click="emit('direction', 'desc')"
      >
        Top {{ result.rows.length }}</button
      ><button
        type="button"
        :class="{ selected: direction === 'asc' }"
        :aria-pressed="direction === 'asc'"
        :disabled="busy"
        @click="emit('direction', 'asc')"
      >
        Bund {{ result.rows.length }}
      </button>
    </div>
    <ol class="ranking-list">
      <li
        v-for="(row, i) in result.rows"
        :key="i"
        :class="'rank-' + (Number(i) + 1)"
      >
        <span class="rank-position"
          ><TrophyIcon
            v-if="Number(i) < 3 && direction === 'desc'"
            :size="Number(i) === 0 ? 28 : 22"
          /><span>{{ Number(i) + 1 }}.</span></span
        >
        <span class="rank-name">{{
          dimensionLabel(
            row.d0,
            result.query.dimensions[0],
            result.schema.fields,
          )
        }}</span>
        <strong class="rank-value"
          >{{
            row[metric.alias] === null
              ? "Ingen værdi"
              : formatDecimal(row[metric.alias])
          }}<small v-if="unit"> {{ unit }}</small></strong
        >
      </li>
    </ol>
    <p class="muted small">
      {{ direction === "desc" ? "Højeste" : "Laveste" }} værdier i den valgte
      periode. Lige værdier sorteres efter kategori.
    </p>
  </div>
</template>
<style scoped lang="scss" src="../styles/components/RankingResult.scss"></style>
